import React from 'react'
import glamorous from 'glamorous'
import PropTypes from 'prop-types'
import ContactThumbnail from 'component-thumbnail'
import { connect } from 'transfer/utils/p2p-connect'

const AvatarContainer = glamorous.div({
  position: 'relative',
  margin: 'auto',
})

const PendingSmall = glamorous.span(
  'ppvx_icon ppvx_icon--size_xl2 ppvx_icon-pending',
  {
    color: '#01cf91',
    position: 'absolute',
    fontSize: '2rem',
    borderRadius: '50%',
    backgroundColor: '#fff',
    bottom: 0,
    right: 0,
  }
)

const DefaultIcon = glamorous.span(
  'ppvx_icon ppvx_icon--size_xl2 ppvx_icon-user',
  {
    color: '#fff',
  }
)

const DefaultAvatarContainer = glamorous.div({
  backgroundImage: 'linear-gradient(10deg, #009CDE, #003087)',
  borderRadius: '50%',
  padding: '1rem',
})

function DefaultAvatar() {
  return (
    <AvatarContainer>
      <DefaultAvatarContainer>
        <DefaultIcon />
      </DefaultAvatarContainer>
      <PendingSmall />
    </AvatarContainer>
  )
}

function Avatar({ thumbnailUrl, firstInitial, lastInitial }) {
  const noInitials = !firstInitial || !lastInitial
  const noThumbnail = !thumbnailUrl || thumbnailUrl.includes('d=blank')

  const showDefault = noInitials && noThumbnail

  if (showDefault) {
    return <DefaultAvatar />
  }

  return (
    <AvatarContainer>
      <ContactThumbnail
        thumbnailUrl={thumbnailUrl}
        firstInitial={firstInitial}
        lastInitial={lastInitial}
      />
      <PendingSmall />
    </AvatarContainer>
  )
}

Avatar.propTypes = {
  thumbnailUrl: PropTypes.string,
  firstInitial: PropTypes.string,
  lastInitial: PropTypes.string,
}

export default connect(({ recipient }) => ({
  thumbnailUrl: recipient.thumbnailUrl,
  firstInitial: recipient.firstInitial,
  lastInitial: recipient.lastInitial,
}))(Avatar)
